'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-512/node_modules/@eliadmin/core/src/components/profile/profile-edit-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-512/node_modules/@eliadmin/core/src/components/profile/profile-edit-form.tsx").ProfileEditForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/profileEditForm").then(m => ({ default: m.ProfileEditForm })));
export function ProfileEditForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

